import { createContext, useContext } from 'react';

export type Theme = 'default' | 'wellbeing';

type FooterPortalContextShape = (element: HTMLDivElement | null) => void;
export const FooterPortalContext = createContext<FooterPortalContextShape>(() => {});
export const useFooterPortal = (): FooterPortalContextShape => useContext(FooterPortalContext);
